import { UserSocieteProfilSelectors } from '@get/store/selectors';
import { SelectorModel } from '@get/utils';

// tslint:disable-next-line: variable-name
export const UserSocieteProfilModel: SelectorModel = {
  name: 'userSocieteProfils',
  getSelector: UserSocieteProfilSelectors.selectAllUserSocieteProfilsDictionary,
  isReady: UserSocieteProfilSelectors.selectIsReadyUserSocieteProfil
};
